import React from 'react';
import { Icon } from '../core/Icon.jsx';

/**
 * Select — native dropdown styled to match Input (dark field, green focus).
 */
export function Select({ label, hint, options = [], disabled = false, style = {}, containerStyle = {}, ...rest }) {
  const [focus, setFocus] = React.useState(false);
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 8, fontFamily: 'var(--font-sans)', ...containerStyle }}>
      {label && (
        <span style={{ fontSize: 'var(--fs-sm)', fontWeight: 'var(--fw-semibold)', color: 'var(--text-muted)' }}>{label}</span>
      )}
      <div style={{ position: 'relative', display: 'flex' }}>
        <select
          disabled={disabled}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          style={{
            appearance: 'none',
            width: '100%',
            height: 'var(--control-h)',
            padding: '0 44px 0 16px',
            background: 'var(--input-bg)',
            border: `${focus ? 2 : 1}px solid ${focus ? 'var(--primary)' : 'var(--border)'}`,
            borderRadius: 'var(--radius)',
            color: 'var(--text-body)',
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--fs-body)',
            fontWeight: 'var(--fw-medium)',
            outline: 'none',
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            ...style,
          }}
          {...rest}
        >
          {options.map((o) => {
            const val = typeof o === 'string' ? o : o.value;
            const lab = typeof o === 'string' ? o : o.label;
            return <option key={val} value={val}>{lab}</option>;
          })}
        </select>
        <span style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
          <Icon name="chevron-down" size={18} color="var(--text-faint)" />
        </span>
      </div>
      {hint && <span style={{ fontSize: 'var(--fs-xs)', color: 'var(--text-hint)' }}>{hint}</span>}
    </label>
  );
}
